module.exports = "<div class=\"input-group date\">\n    <div class=\"input-group-addon\">\n        <i class=\"fa fa-calendar\"></i>\n    </div>\n    <input type=\"text\" class=\"form-control pull-right filter-from-date datepicker_class\" placeholder=\"{{ $ctrl.placeholder }}\">\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/ui/datepicker/datepicker.html
// module id = 506
// module chunks = 0